import styled, { css } from 'styled-components';
import {
  TitleLgReg,
  TitleSmReg,
  BodyXlReg,
  BodyMedReg,
  BodyXsReg,
  BodyXxsReg,
} from '@seed-health/tokens';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';
import type { PillSize } from '.';

const sizeStyles: Record<PillSize, ReturnType<typeof css>> = {
  xl: css`
    ${TitleLgReg}
    --pill-border-width: 3px;
    padding: 9px 12px;
    line-height: 100%;
  `,
  lg: css`
    ${TitleSmReg}
    --pill-border-width: 2.5px;
    padding: 6px 12px;
    line-height: 100%;
  `,
  md: css`
    ${BodyXlReg}
    --pill-border-width: 2px;
    padding: 4px 10px;
    line-height: 100%;
  `,
  sm: css`
    ${BodyMedReg}
    --pill-border-width: 1.75px;
    padding: 3.5px 8px;
    line-height: 100%;
  `,
  xs: css`
    ${BodyXsReg}
    --pill-border-width: 1.25px;
    padding: 3px 6px;
    line-height: 100%;
  `,
  xxs: css`
    ${BodyXxsReg}
    --pill-border-width: 1.25px;
    padding: 1.5px 6px;
  `,
};

// The ® glyph sits higher than ™, so it's lowered to align with the cap height
export const RegisteredMark = styled.sup`
  top: -0.2em;
`;

export const PillWrapper = styled.span<{
  $light?: boolean;
  $sizeBase: PillSize;
  $sizeTablet?: PillSize;
  $sizeDesktop?: PillSize;
  $visibility?: string;
}>`
  display: inline-flex;
  align-items: center;
  ${({ $light }) =>
    $light
      ? `--pill-text: var(--text-inverse-primary); --pill-border: var(--outline-light);`
      : `--pill-text: var(--text-primary); --pill-border: var(--outline-primary);`}
  color: var(--pill-text);
  border: var(--pill-border-width, 1px) solid var(--pill-border);
  border-radius: var(--radius-full);
  font-family: 'Seed Sans';
  width: fit-content;
  height: fit-content;
  sup {
    font-size: 64.5%;
    vertical-align: baseline;
    color: var(--pill-text);
  }
  ${({ $sizeBase }) => sizeStyles[$sizeBase]}
  ${({ $sizeTablet }) =>
    $sizeTablet &&
    css`
      @media ${mqMediumMin} {
        ${sizeStyles[$sizeTablet]}
      }
    `}
  ${({ $sizeDesktop }) =>
    $sizeDesktop &&
    css`
      @media ${mqLargeMin} {
        ${sizeStyles[$sizeDesktop]}
      }
    `}
  ${({ $visibility }) => $visibility && `visibility: ${$visibility};`}
`;
